import React, { lazy, Suspense, useState } from "react"
import "./Admin.css"
import { connect } from "react-redux"
import { Route, Switch, Redirect, Link } from "react-router-dom"
import { ROUTES } from "../common/utils"
import AdminSidebar from "./AdminSidebar"
import AdminAlert from "./AdminAlert"
import HorizontalLogo from "../common/HorizontalLogo"
import Loader from "../common/Loader"
import NotFound from "../common/NotFound"
import AdminName from "./AdminName/AdminName"
import AdminDropdown from "./AdminDropdown/AdminDropdown"
import moment from "moment"

class AdminHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dropDown: "off"
    }
  }

  onDropClick = event => {
    this.setState(state => ({ ...state, dropDown: event }))
  }

  onLinkSelect = route => {
    this.props.history.push(route)
    this.setState(state => ({ ...state, dropDown: "off" }))
  }

  render() {
    const { dropDown } = this.state
    return (
      <div className="AdminHeader">
        <HorizontalLogo onClick={() => this.onLinkSelect(ROUTES.ADMIN)} />
        <AdminName onDropClick={this.onDropClick} dropDown={dropDown} />
        {dropDown === "on" && (
          <AdminDropdown
            onLinkSelect={this.onLinkSelect}
            onDropClick={this.onDropClick}
          />
        )}
      </div>
    )
  }
}

//lazy load components
const Dashboard = lazy(() => import("../Dashboard"))
//lazy load customers pages
const Customers = lazy(() => import("../customer/Customers"))
const AddCustomer = lazy(() => import("../customer/AddCustomer"))
const ViewCustomer = lazy(() => import("../customer/ViewCustomer"))
//lazy load products pages
const ProductRedirect = lazy(() => import("../product/ProductRedirect"))
const Products = lazy(() => import("../product/Products"))
const AddProducts = lazy(() => import("../product/AddProduct"))
//lazy load category pages
const Categories = lazy(() => import("../categories/Categories"))
const AddCategory = lazy(() => import("../categories/AddCategory"))
// lazy load order pages
const Orders = lazy(() => import("../orders/Orders"))
const CreateOrder = lazy(() => import("../orders/CreateOrder"))
const ViewOrder = lazy(() => import("../orders/ViewOrder"))
//lazy load inventory page
const Inventory = lazy(() => import("../inventory/Inventory"))
// lazy load reports pages
const Reports = lazy(() => import("../reports/Reports"))
const AllSalesLocations = lazy(() => import("../reports/AllSalesLocations"))
const AllSalesProducts = lazy(() => import("../reports/AllSalesProducts"))
// lazy load settings pages
const Settings = lazy(() => import("../settings/Settings"))
const AccountSettings = lazy(() => import("../settings/AccountSettings"))
//lazy load settings pages
const PickUpAndDeliverySettings = lazy(() =>
  import("../settings/PickUpAndDeliverySettings")
)
const UserProfile = lazy(() => import("../settings/UserProfile"))
const TaxSettings = lazy(() => import("../settings/TaxSettings"))
const PaymentSettings = lazy(() => import("../settings/PaymentSettings"))
const Referral = lazy(() => import("../Referral/Referral"))

function Admin({
  hasUserInfo,
  hasLatLng,
  hasSellerAccount,
  location,
  history,
  daysLeft,
  trial,
  oldAccNoBrgy
}) {
  const [sidebarHidden, setSidebarHidden] = useState(false)
  console.log({
    hasUserInfo,
    hasLatLng,
    hasSellerAccount,
    location,
    history,
    daysLeft,
    trial,
    oldAccNoBrgy
  })
  if (!hasUserInfo) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.USER_INFO,
          state: { from: location }
        }}
      />
    )
  }
  // else if (!hasLatLng || !hasSellerAccount || oldAccNoBrgy) {
  //   return (
  //     <Redirect
  //       to={{
  //         pathname: ROUTES.CREATE_ACCOUNT,
  //         state: { from: location }
  //       }}
  //     />
  //   )
  // }

  return (
    <div className="Admin">
      <AdminHeader history={history} />
      <div className="Admin-content">
        <AdminAlert sidebarHidden={sidebarHidden} />
        <AdminSidebar setSidebarHidden={setSidebarHidden} />
        <div className="Admin-main">
          <Suspense maxDuration={2000} fallback={<Loader />}>
            <Switch>
              {/* Category Routes */}
              <Route
                exact
                path={ROUTES.ADD_CATEGORY}
                render={props => <AddCategory {...props} />}
              />
              <Route
                path={ROUTES.VIEW_CATEGORY}
                render={props => <AddCategory {...props} />}
              />
              <Route
                path={ROUTES.CATEGORIES}
                render={props => <Categories {...props} />}
              />
              <Route
                exact
                path={ROUTES.DASHBOARD}
                render={props => <Dashboard {...props} />}
              />
              {/* Product Routes */}
              <Route
                path={ROUTES.ADD_PRODUCT}
                render={props => <AddProducts {...props} />}
              />
              <Route
                path={ROUTES.VIEW_PRODUCT}
                render={props => <AddProducts {...props} />}
              />
              <Route
                exact
                path={ROUTES.ALL_PRODUCTS}
                render={props => <Products {...props} />}
              />
              <Route
                exact
                path={ROUTES.PRODUCT}
                render={props => <ProductRedirect {...props} />}
              />
              {/* Customer Routes */}
              <Route
                path={ROUTES.ADD_CUSTOMER}
                render={props => <AddCustomer {...props} />}
              />
              <Route
                path={ROUTES.VIEW_CUSTOMER}
                render={props => <ViewCustomer {...props} />}
              />
              <Route
                path={ROUTES.CUSTOMER}
                render={props => <Customers {...props} />}
              />
              {/* Setting Routes */}
              <Route
                exact
                path={ROUTES.SETTINGS}
                render={props => <Settings {...props} />}
              />
              <Route
                path={ROUTES.ACCOUNT_SETTINGS}
                render={props => <AccountSettings {...props} />}
              />
              <Route
                path={ROUTES.PICK_UP_AND_DELIVERY}
                render={props => <PickUpAndDeliverySettings {...props} />}
              />
              <Route
                path={ROUTES.USER_PROFILE}
                render={props => <UserProfile {...props} />}
              />
              <Route
                path={ROUTES.TAX}
                render={props => <TaxSettings {...props} />}
              />
              <Route
                path={ROUTES.PAYMENT}
                render={props => <PaymentSettings {...props} />}
              />
              {/* Order Routes */}
              <Route
                exact
                path={ROUTES.ORDERS}
                render={props => <Orders {...props} />}
              />
              <Route
                path={ROUTES.CREATE_ORDER}
                render={props => <CreateOrder {...props} />}
              />
              <Route
                path={ROUTES.VIEW_ORDER}
                render={props => <ViewOrder {...props} />}
              />
              {/* Inventory Routes --- !IMPORTANT */}
              <Route
                exact
                path={ROUTES.INVENTORY}
                render={props => <Inventory {...props} />}
              />
              {/* Report Routes */}
              <Route
                exact
                path={ROUTES.REPORTS}
                render={props => <Reports {...props} />}
              />
              <Route
                exact
                path={ROUTES.REPORT_PRODUCTS}
                render={props => <AllSalesProducts {...props} />}
              />
              <Route
                exact
                path={ROUTES.REPORT_LOCATIONS}
                render={props => <AllSalesLocations {...props} />}
              />
              <Route
                exact
                path={ROUTES.REFERRAL}
                render={props => <Referral {...props} />}
              />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </div>
      </div>
      {(trial &&
        daysLeft > 0 && (
          <div className="upgradeBar">
            <p>
              Your free trial is about to end in {daysLeft} days. Please choose
              a Qarabao plan to complete your subscription.{" "}
              <Link
                to={{
                  pathname: ROUTES.TRIAL_EXPIRY
                }}
              >
                Upgrade
              </Link>
            </p>
          </div>
        )) ||
        (trial &&
          daysLeft <= 0 && (
            <div className="upgradeBar">
              <p>
                Your trial has expired. Subscribe to our monthly plan to
                continue using Qarabao.{" "}
                <Link
                  to={{
                    pathname: ROUTES.TRIAL_EXPIRY
                  }}
                >
                  Subscribe
                </Link>
              </p>
            </div>
          ))}
    </div>
  )
}

function mapStateToProps(state) {
  const { account, address } = state.user
  let expireDate = state.user.account.date_expiration
  let today = moment().format("YYYY-MM-DD")
  let trial =
    state.user.account.status.toLowerCase() === "trial" ||
    state.user.account.status.toLowerCase() === "expired"
      ? true
      : false
  let daysLeft = Math.floor(
    moment.duration(moment(expireDate).diff(moment(today))).asDays()
  )
  let userInfoStatus =
    account.mobile !== "undefined" &&
    account.mobile !== "" &&
    account.mobile !== null &&
    (account.mobile_country_code !== "undefined" &&
      account.mobile_country_code !== "" &&
      account.mobile_country_code !== null)
      ? true
      : false
  let LatLngStatus =
    address &&
    address.lng !== "undefined" &&
    address.lng !== "" &&
    address.lng !== null &&
    (address.lat !== "undefined" && address.lat !== "" && address.lat !== null)
      ? true
      : false

  return {
    oldAccNoBrgy:
      state.user.address &&
      (state.user.address.barangay === null ||
        state.user.address.barangay === "") &&
      state.user.address.country === "philippines",
    user: state.user,
    hasUserInfo: userInfoStatus,
    hasLatLng: LatLngStatus,
    hasSellerAccount:
      typeof state.user.seller !== "undefined" &&
      state.user.seller !== null &&
      typeof state.user.seller.account_id !== "undefined",
    daysLeft: daysLeft,
    trial: trial
  }
}
export default connect(mapStateToProps)(Admin)
